import _taggedTemplateLiteral from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import styled from "styled-components";
export var Image = styled.img(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\twidth: ", "px;\n\theight: ", "px;\n"])), function (props) {
  return props.width;
}, function (props) {
  return props.height;
});